module.exports = __webpack_public_path__ + "static/media/BG.083f8c02.jpg";